import { MessageCircle } from "lucide-react";

const FloatingWhatsApp = ({ onOpenWhatsApp }) => {
  return (
    <button
      onClick={onOpenWhatsApp}
      data-testid="floating-whatsapp"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] text-white rounded-full shadow-2xl hover:scale-110 transition-all duration-300 flex items-center justify-center whatsapp-pulse"
      aria-label="WhatsApp"
    >
      <MessageCircle className="w-7 h-7 fill-current" />
    </button>
  );
};

export default FloatingWhatsApp;
